export const isCanceledError = (error) => {
  // Check for axios cancel error
  if (error?.code === 'ERR_CANCELED') return true;
  if (error?.name === 'CanceledError') return true;
  if (error?.name === 'AbortError') return true;
  if (error?.message === 'canceled') return true;
  return false;
};

export const getApiErrorMessage = (error, fallback = 'Something went wrong') => {
  // Don't show message for canceled requests
  if (isCanceledError(error)) {
    return null;
  }

  const response = error?.response;
  const data = response?.data;

  if (data?.message) {
    return data.message;
  }
  if (data?.error) {
    return data.error;
  }

  const status = response?.status;
  if (status === 400) {
    return 'Invalid request. Please check your inputs.';
  }
  if (status === 401) {
    return 'Session expired. Please log in again.';
  }
  if (status === 403) {
    return 'You do not have permission to perform this action.';
  }
  if (status === 404) {
    return 'Requested resource not found.';
  }
  if (status === 429) {
    return 'Too many requests. Please wait a moment and try again.';
  }
  if (status && status >= 500) {
    return 'Server error. Please try again in a moment.';
  }

  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
    return 'Request timed out. Please try again.';
  }
  if (error?.message?.includes('Network Error')) {
    return 'Network error. Please check your connection and try again.';
  }

  return error?.message || fallback;
};

export const isRateLimitError = (error) => {
  return error?.response?.status === 429;
};

